export function checkStatusCode(error: any | undefined, targetStatusCode: number, targetStatus: string) {
  const status = error?.response?.status;
  const statusText = error?.response?.statusText;
  const code = error?.response?.data?.code;

  return status === targetStatusCode && [statusText, code].includes(targetStatus);
}
